import ApiService from './api.service'

const FBoxService = {
	async orderCreate(fbIp, data, saleId) {
		try {
			await ApiService.removeHeader()
			// let response = await ApiService.post(fbIp, data);
			// const token = Buffer.from(`m@y(dutyFr##:m@y(dutyFr##P@$Sw0RD)`, 'utf8').toString('base64')
			var requestData = {
				method: 'post',
				url: `http://localhost:8888/order/create`,
				data: {ipAddress: fbIp, data: data, saleId: saleId},
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},
	async orderRefuse(fbIp, data) {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'post',
				url: `http://localhost:8888/order/refuse`,
				data: {ipAddress: fbIp, data: data},
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},
	async xAndZReportCloseOrPrint({ipAddress, data, closeZReport, salesEur, totalEur}) {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'post',
				url: `http://localhost:8888/zreport/close`,
				data: {closeZReport: closeZReport, ipAddress: ipAddress, data: data, salesEur: salesEur,
					totalEur: parseFloat(totalEur).toFixed(2)},
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},
	async zReportOpen(ipAddress) {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'get',
				url: `http://localhost:8888/zreport/open?ipAddress=${ipAddress}`,
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},

	async getInfoFiscal() {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'get',
				url: `http://localhost:8888/info`,
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},

	async setFiscalIpData(data) {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'put',
				url: `http://localhost:8888/write?id=${data.id}&name=${data.name}&departmentId=${data.departmentId}&departmentName=${data.departmentName}&ipAddress=${data.ipAddress}&isBar=${data.isBar}&isSkyShop=${data.isSkyShop}&documentType=${data.documentType}&depCurrencyType=${data.depCurrencyType}`,
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},
	async getFiscalIpData() {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'get',
				url: `http://localhost:8888/read`,
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	}
}
export default FBoxService
